import styled from 'styled-components'

import { Menu } from 'antd'

const { SubMenu: AntSubMenu } = Menu

const SubMenu = styled(AntSubMenu)``

export default SubMenu
